var _path, _mask, _path2, _mask2, _path3, _mask3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetached = function SvgDetached(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M33.502 16.43V37M33.502 16.43h6.373M33.502 16.43 29.375 9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "detached_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.875 17a2 2 0 1 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.606a.197.197 0 0 1-.197-.197z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.875 17a2 2 0 1 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.606a.197.197 0 0 1-.197-.197z",
    mask: "url(#detached_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "detached_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.875 17a2 2 0 1 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.606a.197.197 0 0 1-.197-.197z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M22.875 17a2 2 0 1 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.606a.197.197 0 0 1-.197-.197z",
    mask: "url(#detached_svg__b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "detached_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 29.43a.43.43 0 0 1 .43-.43h5.14a.43.43 0 0 1 .43.43v7.141a.43.43 0 0 1-.429.429H18.93a.43.43 0 0 1-.429-.429z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 29.43c0-.79.64-1.43 1.43-1.43h5.14c.79 0 1.43.64 1.43 1.43l-2 .57h-4zm7 7.57h-6zm-5.571 0c-.79 0-1.429-.64-1.429-1.429V29.43c0-.79.64-1.43 1.43-1.43l.57 2v7zm5.141-9c.79 0 1.43.64 1.43 1.43v6.141c0 .79-.64 1.429-1.429 1.429H23.5v-7z",
    mask: "url(#detached_svg__c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M13.786 9 9.5 16.929v20.357h30.857V16.714L35.857 9z"
  })));
};
export default SvgDetached;